import React, {createContext, ReactNode, useContext, useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import {QueryString} from "../utils/Querystring";
import TokenUtils from "../utils/tokenUtils";
import {User} from '../types';
import {SIGN_IN_PAGE_URI} from "../constants/uri.constant";
import {AuthService} from "../services";

interface UserProviderProps {
    children: ReactNode;
}

export const UserContext = createContext<any>({});

export const UserProvider: React.FC<UserProviderProps> = ({children}) => {
    const [isReady, setIsReady] = useState<boolean>(false)
    const [user, setUser] = useState<User | null>(null)
    const navigate = useNavigate()

    const getUser = async () => {
        const {access_token, refresh_token} =  await AuthService.getTokens()
        TokenUtils.saveTokens(access_token, refresh_token);
        const userData = await AuthService.getCurrentUser()
        console.log(userData, "userData")
        setUser({
            cor_id: userData.corid,
            email: "roofl3228@gmail.com",
            first_name: userData.first_name,
            id: 8,
            is_active: true,
            is_superuser: false,
            last_name: userData.surname,
            name: [userData.first_name || "", userData.surname || ""].join(' ').trim(),
            role: "company_owner"
        })
    }

    const checkAccessToken = async () => {
        try {
            const accessToken = await TokenUtils.getAccessCorIdToken()

            if (!accessToken) {
                navigate(SIGN_IN_PAGE_URI)
            } else {
                try {
                    await getUser()
                } catch (e) {
                    console.error("Can't get user", e)
                }
            }


            QueryString.removeHash()
            setIsReady(true)
        } catch (e) {
            TokenUtils.logout();
        }
    }

    useEffect(() => {
        console.log('HERE')
        checkAccessToken()
    }, [])

    if (!isReady) {
        return null;
    }

    return (
        <UserContext.Provider value={{user}}>
            {children}
        </UserContext.Provider>
    );
};


export const useUser = () => {
    const context = useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
